import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Announces route changes to screen readers via a visually hidden aria-live region.
 * Without this, SPA navigation is invisible to assistive technology.
 */
export function RouteAnnouncer() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    // Don't announce on initial mount
    if (prevPathRef.current === location.pathname) return;
    prevPathRef.current = location.pathname;

    // Use document.title if set, otherwise derive from pathname
    const title = document.title?.split(' | ')[0]?.trim();
    setAnnouncement(title ? `Navigated to ${title}` : 'Page updated');

    // Clear after screen reader has consumed it
    const id = setTimeout(() => setAnnouncement(''), 1000);
    return () => clearTimeout(id);
  }, [location.pathname]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
}
